function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    }
    else var expires = "";

    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

$(function () {
    var cookie = readCookie('cookie');
    if (cookie) {
        $('#cookies-info').remove();
    }
    $('.close-element').on('click', function(e) {
        e.stopPropagation();
        var el = $(this).is('[data-close-element]') ? '#' + $(this).attr('data-close-element') : '';
        if (el) $(this).parents(el).fadeOut();
        createCookie('cookie', 'true', 10000);
    });
})
